import { BoltSlashIcon } from "@octopusdeploy/design-system-icons";
import { colorScales } from "@octopusdeploy/design-system-tokens";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function StaleIcon(size: LiveStatusIconSize) {
    return (<span className={iconStyle(size)} style={{ background: colorScales.grey[500] }}>
            <BoltSlashIcon size={24}/>
        </span>);
}
